var metaInfo={
    title:"医药行业_Movibot服务行业",
    keywords:"工业机器人_医药行业_药品包装_药品搬运_医疗设备制造",
    description:"工业机器人为医药行业提供药品包装、药品搬运、医疗设备制造、医疗影像相关服务，助力医药行业发展。",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/6.js